import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const Wrapper = styled.label`
  position: relative;
  display: inline-block;
  height: 40px;
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  cursor: ${props => (props.disabled ? "default" : "pointer")};
`

const Slider = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: 0.4s;
  background-color: ${props => props.theme.colors.text.inputLightBackground};
  border-radius: 8px;
  padding: 3px;
`
const Toggle = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props =>
    props.active ? props.theme.colors.primary : props.theme.colors.text.input};
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px 15px;
  border-radius: 8px;
  ${props =>
    props.active
      ? `
      background-color: white;
      box-shadow: 0px 8px 15px 0px rgba(35, 41, 48, 0.15);
  `
      : null};
`

const ToggleSwitch = ({ handleSwitch, active, options, disabled }) => (
  <Wrapper disabled={disabled}>
    <Slider>
      {options.map(item => {
        return (
          <Toggle
            onClick={() => handleSwitch(item.value)}
            key={item.value}
            active={item.value === active}
          >
            {item.name}
          </Toggle>
        )
      })}
    </Slider>
  </Wrapper>
)

ToggleSwitch.defaultProps = {
  disabled: false
}

ToggleSwitch.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  disabled: PropTypes.bool,
  active: PropTypes.string.isRequired,
  handleSwitch: PropTypes.func.isRequired
}

export default ToggleSwitch
